<div class="flex flex-col items-center w-full px-4 sm:px-6 lg:px-8 py-10 gap-12 text-pet-color-text-2">

    <!-- NOSOTROS -->
    <section class="flex flex-col items-center gap-8 w-full max-w-[1000px]">
        <h1 class="text-3xl sm:text-4xl font-black text-center text-pet-color-text-1">
            Nosotros
        </h1>

        <p class="text-center text-base sm:text-lg max-w-[70ch] leading-relaxed">
            PET24App es una plataforma innovadora dedicada al cuidado integral de tus mascotas.
            Conectamos dueños de mascotas con veterinarios profesionales de manera rápida y eficiente.
        </p>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 w-full">
            <article class="flex flex-col gap-3 p-6 rounded-xl border border-gray-200 shadow-sm bg-white">
                <div class="flex items-center gap-2 text-pet-color-5">
                    <mat-icon>pets</mat-icon>
                    <h2 class="text-lg font-bold text-pet-color-text-1">Nuestra Misión</h2>
                </div>
                <p class="text-sm leading-relaxed text-justify">
                    Facilitar el acceso a servicios veterinarios de calidad, permitiendo a los dueños de
                    mascotas agendar citas, gestionar el historial médico y recibir atención profesional
                    para sus peluditos de manera simple y confiable.
                </p>
            </article>

            <article class="flex flex-col gap-3 p-6 rounded-xl border border-gray-200 shadow-sm bg-white">
                <div class="flex items-center gap-2 text-pet-color-5">
                    <mat-icon>visibility</mat-icon>
                    <h2 class="text-lg font-bold text-pet-color-text-1">Nuestra Visión</h2>
                </div>
                <p class="text-sm leading-relaxed text-justify">
                    Ser la plataforma líder en servicios veterinarios digitales, transformando la manera
                    en que las familias cuidan de sus mascotas y promoviendo su bienestar en cada etapa
                    de sus vidas.
                </p>
            </article>

            <article class="flex flex-col gap-3 p-6 rounded-xl border border-gray-200 shadow-sm bg-white">
                <div class="flex items-center gap-2 text-pet-color-5">
                    <mat-icon>location_on</mat-icon>
                    <h2 class="text-lg font-bold text-pet-color-text-1">Dónde estamos</h2>
                </div>
                <p class="text-sm leading-relaxed text-justify">
                    Somos una plataforma digital con alcance en Colombia. Conectamos tutores y centros
                    veterinarios para que la atención de tu mascota esté a un par de clics, disponible
                    cuando la necesites.
                </p>
            </article>
        </div>

        <div class="flex flex-col items-center gap-3 w-full max-w-[640px] p-6 rounded-2xl border-2 border-pet-color-5 bg-pet-color-5/10">
            <mat-icon class="text-pet-color-5" style="font-size:44px;width:44px;height:44px;line-height:44px;">pets</mat-icon>
            <p class="text-center font-bold text-pet-color-5">
                ¡Cuidamos a tus peluditos como si fueran nuestros!
            </p>
        </div>
    </section>

    <!-- SÍGUENOS -->
    <section class="flex flex-col items-center gap-4 w-full">
        <h2 class="text-xl font-bold text-pet-color-text-1">Síguenos</h2>
        <div class="flex flex-wrap items-center justify-center gap-3">
            <a href="https://www.facebook.com/people/PET24/100094193122315/" target="_blank" rel="noopener noreferrer"
                class="flex items-center gap-2 px-4 py-2 rounded-full border border-gray-300 text-sm font-semibold text-pet-color-text-1 hover:border-pet-color-5 hover:text-pet-color-5 transition-colors">
                <img src="assets/images/facebookicon.png" alt="" class="h-5">
                Facebook
            </a>
            <a href="https://www.instagram.com/pet24app/" target="_blank" rel="noopener noreferrer"
                class="flex items-center gap-2 px-4 py-2 rounded-full border border-gray-300 text-sm font-semibold text-pet-color-text-1 hover:border-pet-color-5 hover:text-pet-color-5 transition-colors">
                <img src="assets/images/icon-instagram.png" alt="" class="h-5">
                Instagram
            </a>
        </div>
    </section>

    <!-- ALIADOS -->
    <section *ngIf="aliados.length" class="flex flex-col items-center gap-6 w-full max-w-[1200px]">
        <div class="flex flex-col items-center gap-2 text-center">
            <h2 class="text-xl font-bold text-pet-color-text-1">Nuestros aliados</h2>
            <p class="text-sm text-pet-color-text-7 max-w-[60ch]">
                Marcas y centros veterinarios que acompañan el cuidado de tu mascota.
            </p>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 w-full justify-items-center">
            <app-card-info-vet *ngFor="let aliado of aliados" [publicidad]="aliado"></app-card-info-vet>
        </div>
    </section>

</div>